<template>
    <div class="flex column-sm column-xs step-wrap" :class="step.validClass && step.validClass">
        <div class="step calc-col-9 calc-col-8-sm calc-col-12-xs">
            <h4 v-if="title" class="calc-heading"><b class="step-number">{{ formatedStepNumber}}</b> {{title}}</h4>
            <p v-if="sub_title" v-html="sub_title" class="hidden-xs"></p>
                <div class="flex column-xs">
                        <template v-for="criterion in criteria">
                       <criterion v-if="!criterion.criterionGroup" :key="criterion.id" :criterion="criterion"></criterion>

                        </template>
                </div>


            <slot name="change-mode"></slot>
            <slot name="product-list"></slot>
            <slot name="buttons"></slot>

            <h4 v-if="step.id === 'calculation_mode'" class="calc-heading mode-heading">{{ modeTitle }}</h4>

        </div>
        <div class="calc-col-3 calc-col-4-sm calc-col-12-xs">
            <div v-if="description" class="step-description">
                <img v-if="colorScheme === 'calc-primary-color'" src="./../../src/assets/img/info_ico.png">
                <img v-if="colorScheme === 'calc-secondary-color'" src="./../../src/assets/img/info_ico_blue.png">
                <img v-if="colorScheme === 'calc-tertiary-color'" src="./../../src/assets/img/info_ico_orange.png">
                <div v-html="description"></div>
            </div>
        </div>
    </div>

</template>

<script>

    import Criterion from './Criterion';
    export default {
        data(){
          return {
              colorScheme : this.$color,
          }
        },
        props : ['step', 'step-number', 'criteria', 'is-cart'],
        components:{
            Criterion
        },
        computed : {
            formatedStepNumber(){
                return this.stepNumber.toString().padStart(2,'0')
            },
            title(){
                return this.isCart ? this.step.title+' '+this.$text.heating_type_title[this.$store.getters.getProductsType] : this.step.title
            },
            sub_title(){
                let ico = '<i class="calc-info-ico"></i>';
                if(this.$color === 'calc-primary-color'){
                    ico = '<i class="calc-info-ico"></i>';
                }else if(this.$color === 'calc-secondary-color'){
                    ico = '<i class="calc-info-blue"></i>'
                }else{
                    ico = '<i class="calc-info-ico-orange-mini"></i>'
                }

              return this.step.sub_title ?  this.step.sub_title.replace('[info_ico]', ico) : '';
            },
            description(){
                if(this.isCart && this.$store.getters.getCartProducts.length){
                    return this.$store.getters.getCartProducts.reduce((res, cur)=>{
                       return  `${res}
                            ${res ? '<hr class="divider">' : ''}
                            ${cur.description}`;
                    }, '').trim();
                }
                    return this.isCart ? this.step.description[this.$store.getters.getProductsType] : this.step.description;

            },
            modeTitle(){
                return this.$text.mode[this.$store.getters.getActiveMode].title.replace(/<\/?[^>]+(>|$)/g, "");
            },
            hasProducts(){
                return this.$store.getters.getCartProducts.length;
            }
        },

    }
</script>

<style scoped>
    .step-description{
        border-left: 2px solid var(--text-color);
        padding-left: 14px;
        font-size: 14px;
        line-height: 26px;
        margin-top: 25px;
    }
    .step-number{
        background: var(--bg-color);
        color:#fff;
        font-size: 18px;
        width: 24px;height: 24px;
        border-radius: 4px;
        display: inline-block;
        text-align:center;
        margin-right: 5px
    }

    @media (max-width: 767px) {
        .step-description{margin-top: 40px;}
    }
</style>
<style>
    .divider{
        margin: 35px 0;
    }
    .calc-primary-color .divider{
        border-top: 1px solid var(--text-color);
        color: var(--text-color);
    }
    .calc-secondary-color .divider{
        border-top: 1px solid var(--text-color);
        color: var(--text-color);
    }

</style>